module.exports = __webpack_public_path__ + "static/media/greenCheckmark.46169957.png";